/**
 * PATH: packages/email-hub/src/feature/personal/orgColors.ts
 * FILE_ID: EMAILHUB-PERSONAL-ORGCOLORS-001
 * PURPOSE: Deterministic per-organisation colour helper for the cross-org
 *          Personal workspace (source pills, board-group headers, picker).
 * WHY:     FEAT-2026-06-22-CROSS-ORG-PERSONAL — every org needs a STABLE hue
 *          across the inbox, board mirror and picker so the operator reads the
 *          same colour for the same org everywhere. Kept in its own (non-
 *          component) module so fast-refresh stays happy and the helper can be
 *          shared by several components.
 * FLOW:    org id → stable index into a fixed Tailwind palette → class string.
 */

/** A small, stable palette so each org gets a consistent (but not garish)
 *  hue across renders — keyed by org id so the same org always reads the
 *  same colour in the list. */
const ORG_HUES = [
  'bg-sky-50 text-sky-700 ring-sky-200',
  'bg-violet-50 text-violet-700 ring-violet-200',
  'bg-emerald-50 text-emerald-700 ring-emerald-200',
  'bg-amber-50 text-amber-700 ring-amber-200',
  'bg-rose-50 text-rose-700 ring-rose-200',
  'bg-indigo-50 text-indigo-700 ring-indigo-200',
]

export function orgHue(orgId: number): string {
  return ORG_HUES[Math.abs(orgId) % ORG_HUES.length]
}
